import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import Select from 'react-select';
import FormInput from '../../../components/FormHelpers/formField';
import FormSelectField from '../../../components/FormHelpers/formSelectField';
import {UploadType} from '../../../constants/enums';
import Switch from '../../../components/Switch';
import {isAdmin} from '../../../utils/userUtility';
import UploadTrackFileSelect from './UploadTrackFileSelect';
import BaseButton from '../../../components/button/BaseButton';

@injectIntl
@inject('uploadTrackStore')
@observer
class UploadFormDesktop extends Component {
    render() {
        const {trackUrl, setAudioRef, togglePlay, showFileUpload, onFileError, validated,
            form, fields, handleClearFileInput, onFileChange, previewError, handleTrackName,
            signatures, keys, onChangeKey, scales, onChangeScale, signature, onChangeSignature,
            handleBlur, handleInputChange, filterCharacters, activeInstrument, onSelectInstrument, instruments,
            addToFeed, handleAddToFeedClick, forceMono, handleForceMono, splitAudio, toggleBpm,
            handleSplitAudio, submit, uploadType, onBlur, uploadTrackStore,
            intl: {formatMessage: translate}} = this.props;
        const isDisabledSubmit = !uploadTrackStore.isFormReady;

        return (
            <Fragment>
                <div className="form-group">
                    <div className="upload-form-title"><FormattedMessage id="upload.form.heading"/></div>
                    <div className="upload-form-description"><FormattedMessage id="upload.form.description"/></div>
                    {trackUrl && <audio ref={setAudioRef} onEnded={togglePlay} src={trackUrl} onError={onFileError}/>}
                    {showFileUpload &&
                        <UploadTrackFileSelect
                            fileName={fields.file.value} onClear={handleClearFileInput}
                            onChange={onFileChange}
                            onError={onFileError}
                            previewError={previewError}
                            isValidated={validated}
                        />
                    }
                   {/* <div className="file-input-label">
                        <FormattedMessage id="upload.form.notations"/>
                    </div>

                    <FileAttachList
                        files={attachments}
                        placeholderText="upload.form.notationAttachments"
                        onFileChange={onAttachmentChange}
                        openFilePreview={() => {}}
                        onFileDelete={onAttachmentDelete}
                        disabled={showFileUpload && !audioFileValid}
                    />*/}
                    <FormInput
                        id="upload-track-name-input" type="text" name="trackName" inputPlaceholder={translate({id: 'upload.form.title.placeholder'})}
                        placeholder={translate({id: 'upload.form.title'})} className="form-upload-title"
                        onChange={handleTrackName} onBlur={onBlur} value={fields.trackName.value}
                        error={fields.trackName.error && <FormattedMessage id="upload.form.error.titleEmpty"/>}/>
                    <div className="a-form-row">
                        <div className="a-form-col a-bpm-col" onBlur={handleBlur}>
                            <FormInput
                                type="text" name="bpm" placeholder={<FormattedMessage id={`upload.form.${showFileUpload ? 'fileBpm' : 'bpm'}`}/>}
                                onChange={handleInputChange} onBlur={onBlur} required={true}
                                filterCharacters={filterCharacters} value={fields.bpm.value} error={fields.bpm.error}/>
                        </div>
                        <div className="a-form-col">
                            <button className="bpm-opener-btn" type="button" onClick={toggleBpm}>
                                <span><FormattedMessage id="upload.bpmCalculator.button"/></span>
                            </button>
                        </div>
                    </div>
                    <div className="a-form-row">
                        <div className="a-form-col">
                            <FormSelectField
                                options={keys} value={fields.key.value} onChange={onChangeKey}
                                label={translate({id: 'upload.form.key'})}/>
                        </div>
                        <div className="a-form-col">
                            <FormSelectField
                                options={scales} value={fields.scale.value} onChange={onChangeScale}
                                label={translate({id: 'upload.form.scale'})}/>
                        </div>
                    </div>
                    <div className="a-form-row">
                        <div className="a-form-col">
                            <FormSelectField
                                options={signatures} value={signature} onChange={onChangeSignature}
                                label={translate({id: 'upload.form.signature'})}/>
                        </div>
                        <div className="a-form-col">
                            <div className="a-form-label"><FormattedMessage id="upload.form.instrument"/></div>
                            <Select
                                classNamePrefix="form"
                                className="form-select-container"
                                isClearable={true}
                                value={activeInstrument}
                                onChange={onSelectInstrument}
                                options={instruments}
                                placeholder=""
                            />
                        </div>
                    </div>
                    {isAdmin() &&
                        <div className="a-form-row">
                            <div className="a-form-col">
                                <Switch
                                    containerClass="upload-record-checkbox"
                                    isActive={addToFeed}
                                    onClick={handleAddToFeedClick}
                                    tooltip={{label: translate({id: 'upload.form.addToFeed'})}}
                                    disabled={false}
                                />
                                <Switch
                                    containerClass="upload-record-checkbox"
                                    isActive={forceMono}
                                    onClick={handleForceMono}
                                    tooltip={{label: translate({id: 'upload.form.forceMono'})}}
                                    disabled={false}
                                />
                                <Switch
                                    containerClass="upload-record-checkbox"
                                    isActive={splitAudio}
                                    onClick={handleSplitAudio}
                                    tooltip={{label: translate({id: 'upload.form.splitAudio'})}}
                                    disabled={false}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className="flexbox flex-end upload-form-button">
                    <BaseButton id="upload-track-submit-button" className="upload-btn" disabled={isDisabledSubmit}
                        label={translate({id: `general.${uploadType === UploadType.EditFile ? 'save' : 'upload'}`})} type="submit" onClick={submit}/>
                </div>
            </Fragment>
        );
    }
}

export default UploadFormDesktop;
